<!--
  2021-06-27 C007 Add showFooter property
-->
<template>
  <div id="app">
    <TopBar class="top-bar" v-if="$route.meta.showTopBar" />
    <section
      v-if="$route.meta && $route.meta.seo"
      class="seo-headings"
    >
      <h1>{{ $route.meta.seo.h1 }}</h1>
      <h2
        v-for="(item, index) in $route.meta.seo.h2"
        :key="index"
      >
        {{ item }}
      </h2>
    </section>
    <div id="viewContainer">
      <transition name="slide" mode="out-in">
        <keep-alive v-if="$route.meta.keepAlive" key="keepAlive">
          <router-view/>
        </keep-alive>
        <router-view v-else key="refresh"/>
      </transition>
      <TopBar class="top-bar" v-if="$route.meta.showTopBar" :title="$t('lang.route.'+$route.meta.title)"/>
      <FooterGuide v-if="$route.meta.showFooter" />
    </div>
  </div>
</template>

<script>
import Loading from './components/Loading/index'
import TopBar from './components/TopBar/index'
import FooterGuide from './components/FooterGuide/index'
export default {
  name: 'App',
  components: {Loading, TopBar, FooterGuide},
  mounted () {
    // localStorage.setItem('locale', 'EN')
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
input {
  background: none;
  outline:none;
  border: none;
}
.bigSizeToastMessage span {
  font-size: 1.3em !important;
}
.mint-swipe-indicator {
  background: #4E4E4E;
  opacity: 1;
}
.mint-swipe-indicator.is-active {
  background: #717171;
  opacity: 1;
}
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  color: #686868;
  display: flex;
  flex-direction: column;
  background-color: var(--container);
  .top-bar {
    position: fixed;
    width: 100vw;
    top: 0;
    z-index: 5;
  }
  #viewContainer {
    flex: 1;
    padding-bottom: calc(48vw / 3.6);
    position: absolute;
    width: 100%;
    height: 100%;
  }
  #loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.5);
    text-align: center;
    >div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      img {
        width: 70%;
      }
    }
  }
  .seo-headings {
    position: absolute;
    left: calc(-9999vw / 3.6);
    top: calc(-9999vw / 3.6);
    width: calc(1vw / 3.6);
    height: calc(1vw / 3.6);
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue